import { render, staticRenderFns } from "./HoverPreview.vue?vue&type=template&id=2895ac4b&scoped=true"
import script from "./HoverPreview.vue?vue&type=script&lang=js"
export * from "./HoverPreview.vue?vue&type=script&lang=js"
import style0 from "./HoverPreview.vue?vue&type=style&index=0&id=2895ac4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2895ac4b",
  null
  
)

export default component.exports